import { ref } from "vue";
//useSlateLoader composable 
export function useSlateLoader() {
	const isLoading = ref(false);

	const startLoading = () => {
		isLoading.value = true;
	};
  
	const stopLoading = () => {
		isLoading.value = false;
	};
  
	return {
		isLoading,
		startLoading,
		stopLoading,
	};
	
}
